import React, { FC, useRef, useEffect } from 'react'
import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import animatedBell from 'assets/animatedIcons/animatedBell.json'

import { IAnimatedBellProps } from './AnimatedBell.props'
import './AnimatedBell.scss'

const AnimatedBell: FC<IAnimatedBellProps> = ({ isAnimated }) => {
  const lottieRef = useRef<LottieRefCurrentProps | null>(null)

  useEffect(() => {
    if (isAnimated) {
      lottieRef.current?.goToAndPlay(0, true)
    } else {
      lottieRef.current?.goToAndStop(100, true)
    }
  }, [isAnimated])

  return <Lottie lottieRef={lottieRef} animationData={animatedBell} loop className="animated-bell" />
}

export default AnimatedBell
